<template>
    <v-container class="text-xs-center">
        <v-layout style="width: 100%" class="mb-5">
            <v-spacer />
            <img :src="require('../assets/RepairSmart_White.png')" width="470" height="120" alt=""/>
            <v-spacer />
        </v-layout>
        <p class="subheading">In order to take a courtesy vehicle we need to see your driving license, this must be presented at the time of collection. You may be refused courtesy car for convictions such as DD  (drink driving).</p>
        <h4 class="display-1">COURTESY CAR INSURANCE</h4>
        <p>The courtesy cars provided are £10 + vat per day and are insured through ourselves.  There is however an excess of £420 to pay should any damage occur to the vehicle whilst in the customers’ possession, where there is no third party to claim from.</p>
        <p>You may choose to pay an excess waiver of £18 which would mean there would be no excess to pay in the event of a claim, this is non-refundable.</p>
        <h4 class="display-1">COURTESY CAR PETROL</h4>
        <p>We require the courtesy cars to be returned with the same amount of petrol as when they left the premises.</p>
        <p>The odometer (mileage) will be reset to zero when the vehicle leaves the premises, and the customer will be charged at  40p per mile + VAT on return, if the petrol used has not been refilled as stated above.  Please retain the petrol receipt. If you have not put fuel into the vehicle please ensure you tell us before settling your bill.</p>
        <p>Any Traffic Offences, (Speeding fines, parking tickets, etc.), recorded whilst in the possession of the customer will be solely the customers responsibility</p>
        <p><strong>Pets are not permitted in the courtesy cars at any time.</strong></p>
        <p><strong>No smoking in courtesy cars.</strong></p>
        <p class="text-xs-left">I have a full and clean UK driving license. </p>
        <p class="text-xs-left">I agree that I have read and understand the above statement</p>
        <v-layout class="mt-5">
            <v-flex>
                <h5 class="mt-5 headline text-xs-left"><canvas width="500" height="80" id="canvas" v-on:touchmove="handleTouchMove" v-on:touchstart="handleTouchStart" v-on:touchend="handleTouchEnd" v-on:mousedown="handleMouseDown" v-on:mouseup="handleMouseUp" v-on:mousemove="handleMouseMove" /></h5>
                <h6 class="title text-xs-left mt-1">{{booking.customer.name}}</h6>
                <h6 class="title text-xs-left mt-1">{{currentDate}}</h6>
            </v-flex>
            <v-btn :disabled="isLoading" id="printPageButton" @click="print" class="d-block mt-5" color="primary"><v-icon>mdi-printer</v-icon></v-btn>
            <v-btn :loading="isLoading" :disabled="isLoading" id="saveButton" @click="saveState" class="d-block mt-5" color="primary"><v-icon>mdi-content-save</v-icon></v-btn>
        </v-layout>
    </v-container>
</template>

<script>
    import {EventBus} from '../EventBus';
    import {BookingsHttp} from "../http/bookings";

    export default {
        name: "CCarForm",
        props: {
            id: String
        },
        computed: {
            booking: {
                get() {
                    return this.$store.state.bookings.activeBooking;
                }
            },
            currentMouse: function () {
                const c = document.getElementById("canvas");
                const rect = c.getBoundingClientRect();

                return {
                    x: this.mouse.current.x - rect.left,
                    y: this.mouse.current.y - rect.top
                }
            }
        },
        data() {
            return {
                loaded: false,
                mouse: {
                    current: {
                        x: 0,
                        y: 0
                    },
                    previous: {
                        x: 0,
                        y: 0
                    },
                    down: false
                },
                currentDate: this.$moment().format('DD/MM/YYYY HH:mm'),
                isLoading: false
            }
        },
        mounted() {
            if (this.booking.cCarSigDate) {
                this.currentDate = this.$moment(this.booking.cCarSigDate).format('DD/MM/YYYY HH:mm');
            }
            this.loadState();
        },
        methods: {
            draw: function () {
                if (this.mouse.down) {
                    const c = document.getElementById("canvas");
                    const ctx = c.getContext("2d");
                    ctx.clearRect(0,0,800,800);
                    ctx.lineTo(this.currentMouse.x, this.currentMouse.y);
                    ctx.strokeStyle ="black";
                    ctx.lineWidth = 2;
                    ctx.stroke()
                }
            },
            handleMouseDown: function (event) {
                this.mouse.down = true;
                this.mouse.current = {
                    x: event.pageX,
                    y: event.pageY
                };
                const c = document.getElementById("canvas");
                const ctx = c.getContext("2d");
                ctx.moveTo(this.currentMouse.x, this.currentMouse.y)
            },
            handleTouchStart(event) {
                const c = document.getElementById("canvas");
                if (event.target === c) {
                    event.preventDefault();
                }
                this.mouse.current = this.getTouchPos(c, event);
                const touch = event.touches[0];
                const mouseEvent = new MouseEvent("mousedown", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                c.dispatchEvent(mouseEvent);
            },
            handleTouchEnd(event) {
                const c = document.getElementById("canvas");
                if (event.target === c) {
                    event.preventDefault();
                }
                const mouseEvent = new MouseEvent("mouseup", {});
                c.dispatchEvent(mouseEvent);
            },
            getTouchPos(canvasDom, touchEvent) {
                const rect = canvasDom.getBoundingClientRect();
                return {
                    x: touchEvent.touches[0].clientX - rect.left,
                    y: touchEvent.touches[0].clientY - rect.top
                };
            },
            handleMouseUp: function () {
                this.mouse.down = false;
            },
            handleMouseMove: function (event) {
                this.mouse.current = {
                    x: event.pageX,
                    y: event.pageY
                };
                this.draw(event)
            },
            handleTouchMove(event) {
                const c = document.getElementById("canvas");
                if (event.target === c) {
                    event.preventDefault();
                }
                const touch = event.touches[0];
                const mouseEvent = new MouseEvent("mousemove", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                c.dispatchEvent(mouseEvent);
            },
            print() {
                window.print();
            },
            async saveState() {
                const c = document.getElementById("canvas");
                const canvasContents = c.toDataURL();
                const data = { image: canvasContents, date: Date.now() };
                this.booking.cCarSig = JSON.stringify(data);
                this.booking.cCarSigDate = this.currentDate;
                this.isLoading = true;
                try {
                    await BookingsHttp.updateExistingBooking(this.booking._id, this.booking);
                    EventBus.$emit('message', {message: `Signature Saved`, type:'success'});
                } catch (e) {
                    EventBus.$emit('message', {message: e.message, type: 'error'});
                } finally {
                    this.isLoading = false;
                }
            },
            loadState() {
                if (this.booking.cCarSig) {
                    setTimeout(() => {
                        const data = JSON.parse(this.booking.cCarSig);
                        const image = new Image();
                        const c = document.getElementById("canvas");
                        const ctx = c.getContext("2d");
                        image.onload = function () {
                            ctx.clearRect(0, 0, c.width, c.height);
                            ctx.drawImage(image, 0, 0); // draw the new image to the screen
                        };
                        image.src = data.image;
                    }, 500);
                }
            }
        },
        ready() {
            const c = document.getElementById("canvas");
            const ctx = c.getContext("2d");
            ctx.translate(0.5, 0.5);
            ctx.imageSmoothingEnabled= false;
        }
    }
</script>

<style scoped>
    canvas {
        border-bottom: 1px solid black;
    }

    @media print {
        #printPageButton {
            display: none !important;
        }
        #saveButton {
            display: none !important;
        }
    }
</style>
